module.exports = __webpack_public_path__ + "static/media/logo.6ae95286.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 301
// module chunks = 0